





































































































import {Vue, Component, Watch} from 'vue-property-decorator'
import {$} from '@/facade'
import {NeoHelper} from '@/helpers/NeoHelper'
import {BridgeNetworkHelper} from '@/helpers/BridgeNetworkHelper'
import {TBridgeHistory} from '@/model/bridge/types/BridgeHistory'
import RenderCopy from '@/components/RenderCopy.vue'
import BridgeHistoryScrollableTable from '@/components/BridgeHistoryScrollableTable.vue'
import BridgeStatsFilter from '@/components/BridgeStatsFilter.vue'
import BridgeHistoryPagination from '@/components/BridgeHistoryPagination.vue'

@Component({
  components: {
    BridgeStatsFilter,
    BridgeHistoryScrollableTable,
    BridgeHistoryPagination,
    RenderCopy,
  },
})
export default class BridgeStatsSection extends Vue {
  isWalletHistoryVisible = false
  isDepositSelected = true

  currentPage = 1
  skip = 0

  data: TBridgeHistory[] = []
  networkDepositHistory: TBridgeHistory[] = []
  networkWithdrawHistory: TBridgeHistory[] = []
  walletDepositHistory: TBridgeHistory[] = []
  walletWithdrawHistory: TBridgeHistory[] = []

  poolingInterval: any = null

  hasNextPage() {
    return this.data.length === 10
  }

  hasPreviousPage() {
    return this.currentPage > 1 && this.isDepositSelected
  }

  isOnFirstPage() {
    return this.currentPage === 1
  }

  async handleNextPage() {
    this.currentPage++
    this.skip += 10

    this.changePage()
  }

  async handlePreviousPage() {
    if (this.currentPage <= 1) return

    this.currentPage--
    this.skip -= 10

    this.changePage()
  }

  async handleFirstPage() {
    if (this.currentPage === 1) return

    this.currentPage = 1
    this.skip = 0

    this.changePage()
  }

  async changePage() {
    $.await.init('pageChanged')

    if (this.isDepositSelected && this.isWalletHistoryVisible) {
      await this.populateWalletDepositHistory(this.skip)
    } else if (this.isDepositSelected && !this.isWalletHistoryVisible) {
      await this.populateNetworkDepositHistory(this.skip)
    } else if (!this.isDepositSelected && this.isWalletHistoryVisible) {
      await this.populateWalletWithdrawHistory(this.skip)
    } else {
      await this.populateNetworkWithdrawHistory(this.skip)
    }

    $.await.done('pageChanged')
  }

  mounted() {
    this.populateHistory()

    this.poolingInterval = setInterval(() => {
      if (this.isOnFirstPage()) {
        this.populateHistory()
      }
    }, 60000)
  }

  async populateHistory() {
    const promises: Array<Promise<unknown>> = [
      this.populateWalletDepositHistory(0),
      this.populateWalletWithdrawHistory(0),
      this.populateNetworkDepositHistory(0),
      this.populateNetworkWithdrawHistory(0),
    ]

    await $.await.run(
      'populateHistory',
      async () => await Promise.all(promises)
    )
  }

  beforeDestroy() {
    if (this.poolingInterval) {
      clearInterval(this.poolingInterval)
      this.poolingInterval = null
    }
  }

  chooseWalletHistory() {
    this.isWalletHistoryVisible = true
    this.currentPage = 1
    this.skip = 0

    if (this.isDepositSelected) {
      this.data = this.walletDepositHistory
    } else {
      this.data = this.walletWithdrawHistory
    }
  }

  chooseNetworkHistory() {
    this.isWalletHistoryVisible = false
    this.currentPage = 1
    this.skip = 0

    if (this.isDepositSelected) {
      this.data = this.networkDepositHistory
    } else {
      this.data = this.networkWithdrawHistory
    }
  }

  async populateWalletDepositHistory(skip: number) {
    const n3Address = $.walletAdapter.addressOf(
      'n3',
      BridgeNetworkHelper.network()
    )
    if (!n3Address) return

    const {items} = await NeoHelper.listBridgeDepositHistory(skip, n3Address)

    this.walletDepositHistory = items

    if (this.isWalletHistoryVisible && this.isDepositSelected) {
      this.data = items
    }
  }

  private get bridgedSymbols(): string[] {
    const additionalToken = BridgeNetworkHelper.additionalToken()

    return ['GAS', 'NEO', ...(additionalToken ? [additionalToken.symbol] : [])]
  }

  private async collectWithdrawHistory(skip: number, address?: string) {
    const collected: TBridgeHistory[] = []

    let nextSkip = skip

    do {
      const {items} = await NeoHelper.listBridgeWithdrawHistory(
        nextSkip,
        address
      )

      if (items.length === 0) {
        break
      }

      items
        .filter(
          item =>
            item.from !== '' && this.bridgedSymbols.includes(item.tokenSymbol)
        )
        .forEach(item => {
          if (collected.length < 10) {
            collected.push(item)
          }
        })

      nextSkip += 10
    } while (collected.length < 10)

    return {collected, nextSkip}
  }

  async populateWalletWithdrawHistory(skip: number) {
    const xAddress = $.walletAdapter.addressOf(
      'neoX',
      BridgeNetworkHelper.network()
    )
    if (!xAddress) return

    const {collected, nextSkip} = await this.collectWithdrawHistory(
      skip,
      xAddress
    )

    this.walletWithdrawHistory = collected

    if (this.isWalletHistoryVisible && !this.isDepositSelected) {
      this.skip = nextSkip
      this.data = collected
    }
  }

  async populateNetworkDepositHistory(skip: number) {
    const {items} = await NeoHelper.listBridgeDepositHistory(skip)

    this.networkDepositHistory = items

    if (!this.isWalletHistoryVisible && this.isDepositSelected) {
      this.data = items
    }
  }

  async populateNetworkWithdrawHistory(skip: number) {
    const {collected, nextSkip} = await this.collectWithdrawHistory(skip)

    this.networkWithdrawHistory = collected

    if (!this.isWalletHistoryVisible && !this.isDepositSelected) {
      this.skip = nextSkip
      this.data = collected
    }
  }

  filterDeposit(filter: 'withdraw' | 'deposit') {
    this.currentPage = 1
    this.skip = 0

    if (filter === 'deposit') {
      this.isDepositSelected = true

      if (this.isWalletHistoryVisible) {
        this.data = this.walletDepositHistory
      } else {
        this.data = this.networkDepositHistory
      }
    } else if (filter === 'withdraw') {
      this.isDepositSelected = false

      if (this.isWalletHistoryVisible) {
        this.data = this.walletWithdrawHistory
      } else {
        this.data = this.networkWithdrawHistory
      }
    }
  }

  @Watch('$store.state.walletAdapter.n3.address')
  onN3AddressChange(address: string | null) {
    if (address === null) {
      this.walletDepositHistory = []

      if (this.isWalletHistoryVisible && this.isDepositSelected) {
        this.data = []
      }

      if (this.walletWithdrawHistory.length > 0) {
        this.isWalletHistoryVisible = true
        this.isDepositSelected = false
        this.data = this.walletWithdrawHistory
      }

      this.isWalletHistoryVisible = false
      this.isDepositSelected = true
      this.data = this.networkDepositHistory

      return
    }

    this.isWalletHistoryVisible = true
    this.isDepositSelected = true
    this.data = this.walletDepositHistory

    this.populateHistory()
  }

  @Watch('$store.state.walletAdapter.neoX.address')
  onXAddressChange(address: string | null) {
    if (address === null) {
      this.walletWithdrawHistory = []

      if (this.isWalletHistoryVisible && !this.isDepositSelected) {
        this.data = []
      }

      if (this.walletDepositHistory.length > 0) {
        this.isWalletHistoryVisible = true
        this.isDepositSelected = true
        this.data = this.walletDepositHistory
      }

      this.isWalletHistoryVisible = false
      this.isDepositSelected = true
      this.data = this.networkDepositHistory

      return
    }

    this.isWalletHistoryVisible = true
    this.isDepositSelected = false
    this.data = this.walletWithdrawHistory

    this.populateHistory()
  }
}
